import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";
import { UiState } from "@store/ui/ui-slice-types";

/**
 * Returns the format that the data is displayed
 */
export const dataViewModeSelector: (
  state: RootState
) => UiState["dataViewMode"] = createSelector(
  (state: RootState) => state.ui,
  (uiState) => {
    return uiState.dataViewMode;
  }
);

/**
 * Returns the sidebar property
 */
export const sidebarSelector: (state: RootState) => UiState["sidebar"] =
  createSelector(
    (state: RootState) => state.ui,
    (uiState) => {
      return uiState.sidebar;
    }
  );

/**
 * Returns the search property
 */
export const searchSelector: (state: RootState) => UiState["search"] =
  createSelector(
    (state: RootState) => state.ui,
    (uiState) => {
      return uiState.search;
    }
  );

/**
 * Returns the numUnreadMsg property
 */
export const numUnreadMsgSelector: (
  state: RootState
) => UiState["numUnreadMsg"] = createSelector(
  (state: RootState) => state.ui,
  (uiState) => {
    return uiState.numUnreadMsg;
  }
);

/**
 * Returns the world map style property
 */
export const worldMapStyleSelector: (
  state: RootState
) => UiState["worldMapStyle"] = createSelector(
  (state: RootState) => state.ui,
  (uiState) => {
    return uiState.worldMapStyle;
  }
);

/**
 * Returns whether the page content should span the full width of the main area
 */
export const isContentFullWidthSelector: (
  state: RootState
) => UiState["isContentFullWidth"] = createSelector(
  (state: RootState) => state.ui,
  (uiState) => {
    return uiState.isContentFullWidth;
  }
);
